import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';

import './modal.css'

class Modal extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.modalRoot = document.createElement('div');
    this.modalRoot.classList.add('modal-root');
  }

  componentDidMount() {
    // The portal element is inserted in the DOM tree after
    // the Modal's children are mounted, meaning that children
    // will be mounted on a detached DOM  node. If a child
    // component requires to be attached to the DOM tree
    // immediately when mounted, for example to measure a
    // DOM node, or uses 'autoFocus' in a descendant, add
    // state to Modal and only render the children when Modal
    // is inserted in the DOM tree.
    document.body.appendChild(this.modalRoot);
  }

  componentWillUnmount() {
    document.body.removeChild(this.modalRoot);
  }

  render() {
    
    // Render nothing if the "show" prop is false or dont have any elements
    if (!this.props.show || !this.props.children) {
      this.modalRoot.style.display = 'none';
      return null;
    }
    this.modalRoot.style.display = 'block';
    return ReactDOM.createPortal(
      <div className="backdrop">
        <div className="modalStyle">
          {this.props.children}
        </div>
      </div>,
      this.modalRoot
    );
  }
}

Modal.propTypes = {
  onClose: PropTypes.func.isRequired,
  show: PropTypes.bool,
  children: PropTypes.node
};

export default Modal;


// WEBPACK FOOTER //
// ./src/common/form/modal.jsx